import {ZoneType } from "../../api/models";

export let ZoneTypeDisplay: { [index: number]: string } = {};
ZoneTypeDisplay[ZoneType.Area] = "منطقه";
ZoneTypeDisplay[ZoneType.Country] = "کشور";
ZoneTypeDisplay[ZoneType.City] = "شهر";
ZoneTypeDisplay[ZoneType.Province] = "استان";

